import { BASE_URL } from "../../global";
import axiosWithToken from "./axiosTokenConfig";

export async function allSettings(clientID,companyHierarchy) {

  try {

    let SQLSettingsQuery = {
  "query": "SELECT * FROM settings WHERE status != -1"
};

    const generalSettingsPromise = axiosWithToken
      .post(BASE_URL + `dynamic`, SQLSettingsQuery, {headers:{requestType: 'fetchData'}}) 
      .then((res) => res.data)
      .catch((err) => {
        console.log("setting fetch error : ", err);
        return [];
      });

    let clientSetting = [];
    if (clientID) {
      let SQLQuery = {
  "query": `SELECT * FROM clientSettings WHERE status != -1 AND clientId = '${clientID}' AND ${companyHierarchy ? `companyHierarchy='${companyHierarchy}'` : `companyHierarchy IS NULL`}` };

      clientSetting = await axiosWithToken
        .post(
          BASE_URL +
            `dynamic`, SQLQuery, {headers:{requestType: 'fetchData'}}
        )
        .then((res) => res.data)
        .catch((err) => {
          console.log("setting fetch error : ", err);
          return [];
        });
    }

        const [generalSettings, clientSettings] = await Promise.all([generalSettingsPromise, clientSetting]);

        const mergeSettings = (general, client) => {
            const settingsMap = new Map();

            // Add general settings to map
            general.forEach(setting => {
                settingsMap.set(setting.keyName, setting);
            });

            // Update map with client settings, overriding if keyName exists
            client.forEach(setting => {
                settingsMap.set(setting.keyName, setting);
            });

            // Return combined array without duplicates based on keyName
            return Array.from(settingsMap.values());
        };

        // Merge the arrays
        const combinedSettings = mergeSettings(generalSettings, clientSettings);
        return combinedSettings;
    } catch (error) {
        console.error("Error in allSettings:", error);
        return [];
    }
}
